import { Location } from '@angular/common';

import { BroadcastService } from '../../core/services/broadcast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SectionEditBase } from './section-edit-base';
import { FormGroup } from '@angular/forms';
import { AppTeamMessageService } from '../utils/app-team-message.service';

export class SectionHostBase
{
	protected editScreen?: SectionEditBase; // If the host uses a separate edit screen
	public editForm?: FormGroup; // If the host has its own editing function

	constructor(protected router: Router,
	            protected activatedRoute: ActivatedRoute,
	            protected location: Location,
	            protected broadcastService: BroadcastService,
	            protected appTeamMessageService: AppTeamMessageService)
	{
		// Handle global admin navigating to a new organization when the edit window is open
		// this.broadcastService.userSignedIn.pipe(untilDestroyed(this)).subscribe(() => {
		// 	this.location.go(this.router.createUrlTree([], { relativeTo: this.activatedRoute }).toString());
		// });
	}

	canDeactivate(): Observable<boolean>
	{
		if (this.editScreen !== undefined) return this.editScreen.canDeactivate();
		if (this.editForm === undefined || !this.editForm!.dirty) { return of(true); }
		return this.appTeamMessageService.standardDirtyPrompt;
	}
}
